import createElement from '../../logical-components/createElement';
import svgs from '../../visual-components/svgs';
import '../scss/input.scss';
var buildSearch = function (inputConfig) {
    var label = inputConfig.label, id = inputConfig.id, defaultValue = inputConfig.defaultValue, placeholder = inputConfig.placeholder, onChange = inputConfig.onChange, onClick = inputConfig.onClick, onClear = inputConfig.onClear, onFocus = inputConfig.onFocus, outFocus = inputConfig.outFocus, onEnter = inputConfig.onEnter;
    var wrapper = createElement('div', [
        { type: 'class', value: '_msng-input-wrapper _msng-ss-element' },
    ]);
    wrapper.innerHTML = "\n        <label for='field-".concat(id, "'> ").concat(label, " </label>\n        <input autocomplete=\"off\" data-lpignore=\"true\" id='field-").concat(id, "' value='").concat(defaultValue || '', "' placeholder='").concat(placeholder, "'/>\n        <div class='_msng-clear-icon'> ").concat(svgs.close, " </div>\n        <div class='_msng-search-icon'> ").concat(svgs.search, " </div>\n    ");
    var searchButton = wrapper.querySelector('._msng-search-icon');
    var clearButton = wrapper.querySelector('._msng-clear-icon');
    var input = wrapper.querySelector('input');
    if (searchButton) {
        searchButton.addEventListener('click', function () {
            onClick();
        });
    }
    if (clearButton) {
        clearButton.addEventListener('click', function () {
            if (input.value.length === null) {
                return;
            }
            input.value = '';
            onClear();
        });
    }
    // Apply event listener
    input.addEventListener('input', function (event) {
        if (onChange) {
            onChange(event);
        }
    });
    input.addEventListener('focus', function () {
        if (onFocus) {
            onFocus();
        }
    });
    input.addEventListener('blur', function () {
        if (outFocus) {
            outFocus();
        }
    });
    input.addEventListener('keypress', function (event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            onEnter();
        }
    });
    return wrapper;
};
export default buildSearch;
